/*----------------------------------
- ANALYSIS SIGNALS (SSOT)
----------------------------------*/

// The evidence a single full domain analysis returns, in the order the product's
// detail drawer stacks its cards. The home page's Verify tile scrolls these instead
// of showing an abstract illustration, so the tile states what the analysis actually
// contains rather than suggesting it.
//
// Comparable sales is deliberately absent: `Founder.domains.Get` still returns
// `capComparableSales(plan, [])`, so that drawer card renders empty and the marketing
// site must not claim it. Add it here when the sales archive is wired into
// `DomainMarket.similarSales`.

/*----------------------------------
- CATALOG (SSOT)
----------------------------------*/

export const HOME_ANALYSIS_SIGNALS: readonly string[] = [
    'Summary and factor ratings',
    'Estimated value',
    'Similar domains',
    'Search demand',
    'Reputation and authority',
    'Trademark check',
    'Prior usage history',
    'Business ideas',
    'Registrar paths',
] as const;
